import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import {
  Row,
  Col,
  Breadcrumb,
  Badge,
  Dropdown,
  Button,
  List,
  Avatar,
  Input,
  Drawer,
  Typography,
  Space,
  Menu,
  Form,
  Modal,
} from "antd";
import { UserOutlined } from "@ant-design/icons";
import { AiOutlineLogout, AiFillUnlock } from "react-icons/ai";
import Swal from "sweetalert2";

import { NavLink } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";
import { authActions } from "../../store";
import userSystemApi from "../../api/userSystemApi";
const profile = [
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={0}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM12 7C12 8.10457 11.1046 9 10 9C8.89543 9 8 8.10457 8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7ZM9.99993 11C7.98239 11 6.24394 12.195 5.45374 13.9157C6.55403 15.192 8.18265 16 9.99998 16C11.8173 16 13.4459 15.1921 14.5462 13.9158C13.756 12.195 12.0175 11 9.99993 11Z"
      fill="#111827"
    ></path>
  </svg>,
];

const toggler = [
  <svg
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    key={0}
  >
    <path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path>
  </svg>,
];

function Header({
  placement,
  name,
  subName,
  onPress,
  handleSidenavColor,
  handleSidenavType,
  handleFixedNavbar,
}) {
  useEffect(() => window.scrollTo(0, 0));

  let navigate = useNavigate();
  const dispatch = useDispatch();

  const { user: authUser } = useSelector((x) => x.auth);
  // const userInfo = !authUser ? JSON.parse(authUser) : null;

  const [isChangePassModal, setChangePassModal] = useState(false);
  const [user, setUser] = useState({
    userName: null,
    userId: null,
  });

  const [form] = Form.useForm();

  useEffect(() => {
    setUser({
      userName: authUser?.username,
      userId: authUser?.id,
    });
    // console.log(userInfo.permissions);
  }, []);

  const confirm = Modal.confirm;

  const logOut = () => {
    confirm({
      title: "Bạn có muốn đăng xuất không?",
      onOk() {
        dispatch(authActions.logout()).then((res) => {
          if (res.payload?.status === 204) {
            navigate("/");
          }
        });
      },
      onCancel() {},
    });
  };

  const changePassUser = (data) => {
    const item = {
      oldPassword: data.oldPass,
      newPassword: data.newPass,
    };

    userSystemApi.changePassword(item).then(
      (res) => {
        console.log(res);
        if (res.status === 200) {
          Swal.fire({
            title: "Thành Công!",
            text: "Đổi mật khẩu thành công",
            icon: "success",
            confirmButtonText: "OK",
          });
          setChangePassModal(false);
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: "Đổi mật khẩu thất bại",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
      (err) => {
        console.log(err);
        Swal.fire({
          title: "Thất bại!",
          text: err.response?.data?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  };

  const closePopup = useCallback(() => {
    form.resetFields();
    setChangePassModal(false);
  }, [form]);

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onFinish = useCallback(
    (values) => {
      changePassUser(values);
    },
    [user]
  );

  const menu = (
    <Menu
      items={[
        {
          key: "1",
          label: (
            <a
              href="#"
              onClick={() => {
                setChangePassModal(true);
              }}
            >
              <AiFillUnlock /> &nbsp; Đổi mật khẩu
            </a>
          ),
        },
        {
          key: "2",
          label: (
            <a
              href="#"
              onClick={() => {
                logOut();
              }}
            >
              <AiOutlineLogout /> &nbsp; Đăng xuất
            </a>
          ),
        },
      ]}
    />
  );

  return (
    <>
      <Row gutter={[24, 0]}>
        <Col span={24} md={6}>
          <Breadcrumb>
            <Breadcrumb.Item>
              <NavLink to="/">Trang</NavLink>
            </Breadcrumb.Item>
            <Breadcrumb.Item style={{ textTransform: "capitalize" }}>
              {name.replace("/", "-")}
            </Breadcrumb.Item>
          </Breadcrumb>

          <div className="ant-page-header-heading">
            <span
              className="ant-page-header-heading-title"
              style={{ textTransform: "capitalize" }}
            >
              {subName.replace("/", "-")}
            </span>
          </div>
        </Col>
        <Col span={24} md={18} className="header-control">
          <Space>
            <Button
              type="link"
              className="sidebar-toggler"
              onClick={() => onPress()}
            >
              {toggler}
            </Button>
            <label style={{ textTransform: "uppercase" }}>
              <b>{user.userName}</b>
            </label>
            <Dropdown overlay={menu} placement="bottomLeft">
              <Button type="black">{profile}</Button>
            </Dropdown>
          </Space>
        </Col>
      </Row>

      <Modal
        title="Đổi mật khẩu"
        visible={isChangePassModal}
        onOk={form.submit}
        onCancel={() => {
          closePopup();
        }}
      >
        <div>
          <Form
            form={form}
            name="basic"
            layout="vertical"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Form.Item
              label="Mật khẩu cũ"
              name="oldPass"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập mật khẩu cũ!",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Mật khẩu mới"
              name="newPass"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập mật khẩu mới!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </>
  );
}

export default Header;
